import { useSelector, useDispatch } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isSubscriptionExpired } from "../../../utils/subscriptionUtils";
import { logoutMerchant } from "../../../features/merchant/merchantThunks";
import featureFlags from "../../../config/featureFlags";

const ProtectedRoute = ({
  allowedRoles = [],
  requireSubscription = false,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { user, accessToken } = useSelector((state) => state.merchant);
  const { mySubscription, loadingMySubscription } = useSelector(
    (state) => state.subscription
  );

  /* =========================
     1️⃣ AUTH CHECK
  ========================== */
  if (!accessToken || !user) {
    return (
      <Navigate
        to="/merchant-login"
        replace
        state={{ from: location }}
      />
    );
  }

  /* =========================
     2️⃣ ROLE CHECK
  ========================== */
  if (
    allowedRoles.length > 0 &&
    !allowedRoles.includes(user.role)
  ) {
    return user.role === "merchant" ? (
      <Navigate to="/dashboard" replace />
    ) : (
      <Navigate to="/dashboard" replace />
    );
  }

  /* =========================
     3️⃣ SUBSCRIPTION CHECK
  ========================== */
  if (requireSubscription) {
    // wait till subscription loads (prevents flicker)
    if (loadingMySubscription) return null;

    const subscriptionEnabled =
      user?.role === "merchant"
        ? featureFlags.ENABLE_MERCHANT_SUBSCRIPTION
        : featureFlags.ENABLE_USER_SUBSCRIPTION;

    // no subscription OR expired — only block if subscription is enabled for this role
    if (subscriptionEnabled && (!mySubscription || isSubscriptionExpired(mySubscription))) {
      return <Navigate to="/buy-subscription" replace />;
    }
  }

  /* =========================
     ACCESS GRANTED
  ========================== */
  return <Outlet />;
};

export default ProtectedRoute;
